import React, { useState } from "react";
import { connect } from "react-redux";
import { useFormContext } from "react-hook-form";

import { ViewType } from "../../../../assets";
import { EMPTY_STRING } from "../../../../constants";
import ViewTypesIconMapping from "../../../../assets/icons/ViewTypesIconMapping";
import { getSelectOptions } from "../../../../shared/utility";
import CustomSelect from "../../../../shared/components/select/CustomSelect";
import SliderControls from "../../../../shared/components/slider/SliderControls";

const ViewTypes = ({ allViewTypes }) => {
  const {
    setValue,
    getValues,
    formState: { errors },
    trigger,
  } = useFormContext();

  const [currentPage, setCurrentPage] = useState(1);

  const toggleSelectProperty = (property) => {
    const selected = getValues("viewTypeIds") ?? [];
    setValue(
      "viewTypeIds",
      selected.includes(property.id)
        ? selected.filter((id) => id !== property.id)
        : [...selected, property.id]
    );
    trigger("viewTypeIds");
  };
  return (
    <div className="create-form-card">
      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <div className="form-card-heading">
          <img src={ViewType} alt={EMPTY_STRING} />
          Select View Type
        </div>
        <CustomSelect
          options={getSelectOptions(allViewTypes, "title", "id")}
          isMulti
          className="w-auto types-select"
          name="viewTypeIds"
          showError={false}
          isClearable={false}
          defaultStyle={false}
        />
      </div>
      <div className="options">
        {allViewTypes
          .slice((currentPage - 1) * 10, currentPage * 10)
          .map((option, index) => (
            <div
              key={index}
              className={`option ${
                (getValues("viewTypeIds") ?? []).includes(option.id)
                  ? "selected-option"
                  : EMPTY_STRING
              }`}
              onClick={() => toggleSelectProperty(option)}
            >
              <img
                alt={EMPTY_STRING}
                src={ViewTypesIconMapping[option.icon]}
                className="create-listing-view-types-icon"
              />
              {option.title}
            </div>
          ))}
      </div>
      {errors.viewTypeIds && (
        <div className="error mt-2 w-100">{errors.viewTypeIds.message}</div>
      )}
      <div className="slider-controls">
        <SliderControls
          className="mt-2 mb-1"
          length={Math.ceil(allViewTypes.length / 10)}
          changeIndex={(index) => setCurrentPage(index + 1)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allViewTypes: state.propertyReducer.allViewTypes,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewTypes);
